import type { ReactNode } from 'react';
import styles from './FilterBar.module.css';

interface FilterBarProps {
  tabs?: ReactNode;
  search?: ReactNode;
  sort?: ReactNode;
  extraFilters?: ReactNode;
}

export function FilterBar({ tabs, search, sort, extraFilters }: FilterBarProps) {
  return (
    <div className={styles.bar} data-testid="filter-bar">
      {tabs && <div className={styles.tabs}>{tabs}</div>}
      <div className={styles.controls}>
        {search && <div className={styles.search}>{search}</div>}
        {sort && <div className={styles.sort}>{sort}</div>}
        {extraFilters && <div className={styles.extra}>{extraFilters}</div>}
      </div>
    </div>
  );
}
